/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_CookiesInputs */

const es_footer_cookies = /** @type {(inputs: Footer_CookiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cookies`)
};

const gl_footer_cookies = /** @type {(inputs: Footer_CookiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cookies`)
};

const en_footer_cookies = /** @type {(inputs: Footer_CookiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cookies`)
};

/**
* | output |
* | --- |
* | "Cookies" |
*
* @param {Footer_CookiesInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const footer_cookies = /** @type {((inputs?: Footer_CookiesInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_CookiesInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_footer_cookies(inputs)
	if (locale === "en") return en_footer_cookies(inputs)
	return es_footer_cookies(inputs)
});